import {useLocation, useNavigate, useParams} from 'react-router-dom';
import BaseLegalDocument from '../BaseFinancialInstruments/legalDocuments/BaseLegalDocuments';
import {useDispatch, useSelector} from 'react-redux';
import {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import {Spin} from 'antd';
import {ConfirmModal} from 'pages/adminOpportunities/stocksListings/ViewOrders/HandleOrders';
import {
  currentInstrumentKey,
  financialInstrumentConfig,
} from '../modules/financialInstrumentConfig';

export const BondsLegalDocument = () => {
  const location = useLocation();
  const {
    mutation,
    handleUpdate,
    stepTwoRoute,
    handleDispatch,
    title,
    overviewSelector,
    QUERY,
  } = financialInstrumentConfig[currentInstrumentKey(location.pathname)];

  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [updatedValues, setUpdatedValues] = useState({});
  const navigate = useNavigate();
  const {assetId, lang, id} = useParams();
  const dispatch = useDispatch();
  const data = useSelector(overviewSelector);

  const [updateBond, {loading: loadingUpdate}] = useMutation(mutation);
  const {
    data: updateData,
    refetch,
    loading,
  } = useQuery(QUERY, {
    variables: {
      getFinancialInstrumentId: id,
      language: lang,
    },
    skip: !id,
  });

  const handleSubmit = values => {
    if (id) {
      setOpenUpdateModal(true);
      setUpdatedValues(values);
    } else {
      dispatch(handleDispatch({...values}));
      // Documents is the last screen of step 1 now that the migrated-away
      // tabs are gone, so it hands off to step 2.
      navigate(stepTwoRoute({param: assetId, name: ''}));
    }
  };

  if (loading) {
    return (
      <div className="query-loading">
        <Spin size="large" />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div>
      <BaseLegalDocument
        onSubmit={handleSubmit}
        existingData={
          id ? updateData?.getFinancialInstrument?.data || {} : data
        }
      />
      <ConfirmModal
        openModal={openUpdateModal}
        setOpenModal={() => setOpenUpdateModal(false)}
        loading={loadingUpdate}
        title={`Update ${title}`}
        confirmText={`Are you sure you want update to this ${title}?`}
        handleOperation={() =>
          handleUpdate(
            updateBond,
            id,
            lang,
            updatedValues,
            refetch,
            setOpenUpdateModal,
          )
        }
      />
    </div>
  );
};
